import { cn, formatDate } from '@/utils/format';
import { formatNumber } from '@/utils/numbers-utils';
import { ReactNode } from 'react';

interface DateUsageIndicatorProps {
  label?: ReactNode;
  date?: string | null;
  is_past_due_time?: boolean;
  usage?: number | null;
  is_past_due_usage?: boolean;
  unit?: string | null;
  dividerLabel?: string;
  className?: string;
  onClick?: () => void;
}

export const DateUsageIndicator = ({
  label,
  date,
  is_past_due_time,
  usage,
  is_past_due_usage,
  unit,
  dividerLabel = 'at',
  className,
  onClick,
}: DateUsageIndicatorProps) => {
  return (
    <div className="flex flex-row items-center flex-wrap gap-x-1.5 gap-y-1">
      {label}
      {date && (
        <span
          className={cn(
            'px-1.5 py-0.5 rounded border font-mono text-xs',
            is_past_due_time
              ? 'border-red-200 bg-red-100 text-red-700 dark:border-red-700 dark:bg-red-900/30 dark:text-red-300'
              : 'border-border bg-muted/50 text-foreground/80',
            className,
          )}
          onClick={onClick}
        >
          {formatDate(date, 'MM/dd/yyyy')}
        </span>
      )}
      {!date && !usage && (
        <span className="px-1.5 py-0.5 border rounded border-border bg-muted/50 font-mono text-xs text-muted-foreground/50 italic">
          —
        </span>
      )}
      {!!usage && (
        <>
          <span className="text-[10px] text-muted-foreground/60">{dividerLabel}</span>
          <span
            className={cn(
              'px-1.5 py-0.5 rounded border font-mono text-xs',
              is_past_due_usage
                ? 'border-red-200 bg-red-100 text-red-700 dark:border-red-700 dark:bg-red-900/30 dark:text-red-300'
                : 'border-border bg-muted/50 text-foreground/80',
              className,
            )}
            onClick={onClick}
          >
            {formatNumber(usage.toString(), 'numeric')}
          </span>
          <span className="text-xs text-muted-foreground/70">{unit}</span>
        </>
      )}
    </div>
  );
};
